var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163,170.12H37a9.8,9.8,0,0,1-9.78-9.79V105.84a2,2,0,0,1,.83-1.63,2,2,0,0,1,1.81-.27,217.16,217.16,0,0,0,70.72,11.58,218.24,218.24,0,0,0,69.64-11.58,2,2,0,0,1,1.81.27,2,2,0,0,1,.83,1.63v54.49A9.8,9.8,0,0,1,163,170.12ZM31.18,108.61v51.72A5.79,5.79,0,0,0,37,166.12H163a5.79,5.79,0,0,0,5.78-5.79V108.61a222.26,222.26,0,0,1-68.27,10.91A220.72,220.72,0,0,1,31.18,108.61Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100,120.81a194.5,194.5,0,0,1-79.34-17A2,2,0,0,1,19.5,102V61.07c0-4.39,4.67-7.83,10.63-7.83H169.87c6,0,10.63,3.44,10.63,7.83V102a2,2,0,0,1-1.18,1.82,194.53,194.53,0,0,1-78.66,17ZM23.5,100.65a190.93,190.93,0,0,0,77.14,16.16,190.46,190.46,0,0,0,75.86-16.16V61.07c0-1.81-2.72-3.83-6.63-3.83H30.13c-3.91,0-6.63,2-6.63,3.83Zm155,1.3h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.36,57.24H76.64a2,2,0,0,1-2-2V37.88a8,8,0,0,1,8-8h34.72a8,8,0,0,1,8,8V55.24A2,2,0,0,1,123.36,57.24Zm-44.72-4h42.72V37.88a4,4,0,0,0-4-4H82.64a4,4,0,0,0-4,4Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 22.38,
    y: 57.14,
    width: 154.25,
    height: 48.36,
    rx: 4.37
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 35.38,
    y: 80.14,
    width: 130.25,
    height: 30.36,
    rx: 4.37
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 49.38,
    y: 84.14,
    width: 100.25,
    height: 31,
    rx: 4.37
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 86.38,
    y: 117.14,
    width: 27.25,
    height: 13.36,
    rx: 4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 78.38,
    y: 30.14,
    width: 44.25,
    height: 43.36,
    rx: 4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 86.38,
    y: 107.14,
    width: 27.25,
    height: 13.36,
    rx: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobIcon);
export default __webpack_public_path__ + "static/media/job-icon.5f3ad5662ad3ec8a5bd1ca4fad9f3ddf.svg";
export { ForwardRef as ReactComponent };